import React from 'react';
import styles from './CardAjaxLoader.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CardAjaxLoader = ({ modifiers = [] }) => {
    return (
        <div
            className={classNames(
                styles['CardAjaxLoader'],
                modifiers.map((mod) => styles['CardAjaxLoader--' + mod])
            )}>
            <div className={styles['CardAjaxLoader__TimelineItem']}>
                <div className={styles['CardAjaxLoader__AnimatedBackground']}>
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles['CardAjaxLoader__BackgroundMasker--Box']
                        }
                    />
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles['CardAjaxLoader__BackgroundMasker--BoxEnd']
                        }
                    />
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles['CardAjaxLoader__BackgroundMasker--FirstEnd']
                        }
                    />
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles[
                                'CardAjaxLoader__BackgroundMasker--SecondLine'
                            ]
                        }
                    />
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles[
                                'CardAjaxLoader__BackgroundMasker--SecondEnd'
                            ]
                        }
                    />
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles[
                                'CardAjaxLoader__BackgroundMasker--ThirdLine'
                            ]
                        }
                    />
                    <div
                        className={
                            styles['CardAjaxLoader__BackgroundMasker'] +
                            ' ' +
                            styles['CardAjaxLoader__BackgroundMasker--ThirdEnd']
                        }
                    />
                </div>
            </div>
        </div>
    );
};

CardAjaxLoader.propTypes = {
    modifiers: PropTypes.array,
};

export default CardAjaxLoader;
